import { render, staticRenderFns } from "./GColorFormInput.vue?vue&type=template&id=8e1f6226&"
import script from "./GColorFormInput.vue?vue&type=script&lang=ts&"
export * from "./GColorFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./GColorFormInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports